module.exports = __webpack_public_path__ + "img/CF_2V.1.a25e28ca.jpg";